module.exports = __webpack_public_path__ + "static/media/persona_transferencia_asistida.37bf5089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/TransferCall/persona_transferencia_asistida.svg
// module id = 1843
// module chunks = 0